import { Component, OnInit, inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { first } from 'rxjs/operators';

import { User } from '@shared/models/user.model';
import { UserService } from '@shared/services/user.service';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { EventManager } from '@app/shared/utils/event-manager';
import { LoggerService } from '@app/shared/services/logger.service';
import { DecimalPipe } from '@angular/common';
import { HelperService } from '@app/shared/services/helper.service';
import { SharedModule } from '@app/shared/shared.module';

@Component({
  selector: 'slotcom-info-golden-bomb-modal',
  templateUrl: './info-golden-bomb.component.html',
  styleUrls: ['./info-golden-bomb.component.scss'],
  standalone: true,
  imports: [DecimalPipe, SharedModule],
})
export class InfoGoldenBombModalComponent implements OnInit {
  dialog = inject(MatDialog);
  helperService = inject(HelperService);
  userService = inject(UserService);
  logger = inject(LoggerService);
  private eventManager = inject(EventManager);
  private infoGoldenBombModalData = inject<Modal>(MAT_DIALOG_DATA);

  bombValue = 0;
  user: User;
  constructor() {
    const infoGoldenBombModalData = this.infoGoldenBombModalData;

    this.bombValue = infoGoldenBombModalData.data.totalBonus;
  }

  ngOnInit() {
    this.userService.currentUser$.pipe(first()).subscribe({
      next: (user: User) => {
        this.user = user;
      },
      error: (error) => this.logger.error(error),
    });
  }

  public closeDialog() {
    this.eventManager.closeModal(new Modal(NonPersistedModalName.InfoGoldenBombModalComponent, ModalType.View));
  }
}
